// Flag REACT_APP_LOGO_DRAG_RESIZE: the corner handle draws attention to
// itself with a short pulse the FIRST time the editor shows it in a browser
// session (sessionStorage), so a reseller who has never seen it notices
// it once without being nagged on every logo. Never under
// prefers-reduced-motion, and never where matchMedia is missing (jsdom in
// the tests) - so a test render carries no animation node.
export const RESIZE_HANDLE_PULSE_KEY = "kitmaker.logoResizeHandle.pulsed";

// How long the pulse rings run (3 x 1 s in tailwind.config.js) plus a small
// margin before the ring element is removed again.
export const RESIZE_HANDLE_PULSE_MS = 3300;

interface PulseWindow {
  matchMedia?: (query: string) => { matches: boolean };
  sessionStorage?: {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
  };
}

/**
 * True exactly once per browser session (the first call claims it), and
 * only when motion is welcome. Storage that is missing or throws (private
 * mode, blocked site data, quota) simply means "no pulse".
 */
export function claimResizeHandlePulse(
  win: PulseWindow | undefined = typeof window === "undefined"
    ? undefined
    : (window as unknown as PulseWindow)
): boolean {
  if (!win) return false;
  try {
    if (typeof win.matchMedia !== "function") return false;
    if (win.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return false;
    }
    const store = win.sessionStorage;
    if (!store) return false;
    if (store.getItem(RESIZE_HANDLE_PULSE_KEY)) return false;
    store.setItem(RESIZE_HANDLE_PULSE_KEY, "1");
    return true;
  } catch {
    return false;
  }
}
